import { render, staticRenderFns } from "./HandoverPopover.vue?vue&type=template&id=70d3511e"
import script from "./HandoverPopover.vue?vue&type=script&lang=js"
export * from "./HandoverPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports